import { Box, Divider, IconButton, SlidersHIcon, Typography, useTheme } from '../..';
import { CardTablePaginationControls } from './index';
import { Checkbox, Collapse } from '@material-ui/core';
import { leftDesktopPadding } from './Shared';
import React from 'react';
export const CardTableHeader = ({ filter, expandableFilters, filtersExpanded, selectableState, onSelectionChange, numActiveFilters, showModal, header, paginationProps, isMobile, }) => {
    const theme = useTheme();
    const headerNode = typeof header !== 'string' ? (header) : (React.createElement(Typography, { variant: "h6", color: "secondary" }, header));
    const spacer = React.createElement(Box, { mx: 2 }, React.createElement(Divider, { orientation: "vertical", style: { height: theme.spacing(4) } }));
    const handleSelectionChange = (event, checked) => onSelectionChange && onSelectionChange(checked ? 'checked' : 'unchecked');
    const checkboxState = selectableState === 'indeterminate';
    return (React.createElement(Box, { width: "100%", display: "flex", flexDirection: "column" },
        React.createElement(Box, { width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" },
            React.createElement(Box, { display: "flex", alignItems: "center" },
                selectableState && (React.createElement(React.Fragment, null,
                    React.createElement(Box, { ml: isMobile ? 2 : leftDesktopPadding, style: { paddingLeft: 1 } },
                        React.createElement(Checkbox, { edge: "start", onChange: handleSelectionChange, indeterminate: checkboxState ? checkboxState : undefined, checked: selectableState === 'checked' })),
                    spacer)),
                filter && (React.createElement(React.Fragment, null,
                    React.createElement(IconButton, { onClick: showModal },
                        React.createElement(SlidersHIcon, null)),
                    Boolean(numActiveFilters) && React.createElement(Typography, { color: "secondary" },
                        "(",
                        numActiveFilters,
                        ")"),
                    spacer)),
                headerNode),
            paginationProps && React.createElement(CardTablePaginationControls, Object.assign({}, paginationProps))),
        expandableFilters && (React.createElement(Box, null,
            React.createElement(Collapse, { in: filtersExpanded }, expandableFilters)))));
};
//# sourceMappingURL=Header.js.map